import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useTheme } from '@mui/material/styles';

/**
 * EmptyState — sekcja 8.14 UI Design Direction.
 * Jasne wyjaśnienie co się pojawi, element marki, jedna akcja.
 */
function EmptyState({ icon, title, description, actionLabel, onAction, actionIcon }) {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        py: 8,
        px: 3,
      }}
    >
      {icon && (
        <Box
          sx={{
            width: 72,
            height: 72,
            borderRadius: `${theme.tokens?.primitive?.radius?.hero ?? 30}px`,
            bgcolor: theme.tokens?.semantic?.surface?.brandTint ?? theme.palette.primary.light,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'primary.main',
            mb: 3,
            fontSize: 32,
          }}
        >
          {icon}
        </Box>
      )}
      <Typography
        variant="h6"
        sx={{ fontFamily: theme.typography.h1.fontFamily, mb: 1, maxWidth: 360 }}
      >
        {title}
      </Typography>
      {description && (
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3, maxWidth: 320 }}>
          {description}
        </Typography>
      )}
      {actionLabel && (
        <Button
          variant="contained"
          onClick={onAction}
          startIcon={actionIcon}
          sx={{ borderRadius: `${theme.tokens?.primitive?.radius?.pill ?? 999}px` }}
        >
          {actionLabel}
        </Button>
      )}
    </Box>
  );
}

export default EmptyState;
